var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradFacesPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 167,
    viewBox: "0 0 167 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 83.5,
    r: 83.5,
    fill: "url(#paint0_radial_58_5016)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_58_5016",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.5 23.5) rotate(-167.159) scale(105.735 63.2104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FB7A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1840"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradFacesPattern);
export default __webpack_public_path__ + "static/media/gradFacesPattern.d928cca32a36c89a39d5eebf7dfacc85.svg";
export { ForwardRef as ReactComponent };